import { RowCrudStatus } from "../../common/types";
import { EditionContractPublisher } from "../../../api/graphql";
import { LangStore } from "../../../store";
import { publisherDisplayId } from "../../publisher/store/PublisherCommonStore";

export type EditionContractPublisherValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  __publisher: string;
  showPublisher: { displayId: string; id: string } | null;
  percentage: number;
};

export type EditionContractPublisherErrorsType = {
  publisher?: { message: string; fieldLabel: string };
  percentage?: { message: string; fieldLabel: string };
};

export function EditionContractPublisherValuesInit(): EditionContractPublisherValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    __publisher: "",
    showPublisher: null,
    percentage: 0,
  };
}

export type EditionContractPublisherType =
  | EditionContractPublisher
  | EditionContractPublisherValuesType;

export function editionContractPublisherDisplayId(
  source: Partial<EditionContractPublisher>,
  _langStore: LangStore
) {
  return (
    (source.publisher
      ? publisherDisplayId(source.publisher, _langStore)
      : _langStore.emptyStringSymbol) +
    " " +
    (source.percentage?.toString() ?? _langStore.emptyStringSymbol) +
    "%"
  );
}

export function getEditionContractPublisherValues(
  source: EditionContractPublisherType,
  _langStore: LangStore,
  _duplicated: boolean = false
): EditionContractPublisherValuesType {
  const entityValues = EditionContractPublisherValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : editionContractPublisherDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.showPublisher =
    "publisher" in source && source.publisher
      ? {
          id: source.publisher.id,
          displayId: publisherDisplayId(source.publisher, _langStore),
        }
      : "showPublisher" in source && source.showPublisher
      ? {
          id: source.showPublisher.id,
          displayId: source.showPublisher.displayId,
        }
      : null;
  entityValues.__publisher = entityValues.showPublisher?.displayId || "";
  entityValues.percentage = Number(source.percentage) || 0;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
